/* All my Blue — About collage
   Portrait grows a little and moves down as the section scrolls in, the two
   side photos drift at different speeds, and the statement inks in word by
   word. Without motion (setting off or reduced motion) the CSS shows the
   final state and this does nothing. */
(function () {
  var root = document.documentElement;
  function init(abt) {
    if (abt.getAttribute('data-ready')) return;
    abt.setAttribute('data-ready', '1');
    if (!root.classList.contains('amb-motion')) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    abt.classList.add('is-live');
    var grow = abt.querySelector('[data-grow]');
    var ink = abt.querySelector('[data-ink]');
    var ws = ink ? Array.prototype.slice.call(ink.querySelectorAll('.amb-abt__w')) : [];
    var fls = Array.prototype.slice.call(abt.querySelectorAll('[data-speed]'));
    var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
    function tick() {
      var vh = window.innerHeight || 900;
      var r = abt.getBoundingClientRect();
      if (r.bottom > -200 && r.top < vh + 200) {
        if (grow) {
          var t = Math.max(0, Math.min(1, (vh - r.top) / vh));
          var dy = grow.offsetHeight * 0.45 * ease(t);
          grow.style.transform = 'translateY(' + dy.toFixed(1) + 'px) scale(' + (0.75 + 0.4 * ease(t)).toFixed(3) + ')';
        }
        if (ws.length) {
          var b = ink.getBoundingClientRect();
          var q = Math.max(0, Math.min(1, (vh * 0.88 - b.top) / (b.height + vh * 0.3)));
          var n = Math.round(q * ws.length);
          ws.forEach(function (w, i) { w.classList.toggle('is-on', i < n); });
        }
        var y = -r.top;
        fls.forEach(function (f) { f.style.transform = 'translateY(' + (y * parseFloat(f.getAttribute('data-speed')) * -1).toFixed(1) + 'px)'; });
      }
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }
  function boot() { document.querySelectorAll('[data-amb-abt]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
